// --------------------------------------------------------------
// Created On: 2023-12-28
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { Fragment } from "react";
import styles from "./SuccessStatusIcon.module.scss";

// Icon that either represents a loading state, success, or failure.
export default function SuccessStatusIcon(props: Props): Component {
  return props.loading ? (
    <i className={`${styles.loadingIcon} fa fa-fw fa-circle-o-notch fa-spin ${props.className}`} />
  ) : (
    <Fragment>
      {props.successful ? (
        <i className={`${styles.successIcon} fa fa-fw fa-check-circle ${props.className}`} />
      ) : (
        <i className={`${styles.failedIcon} fa fa-fw fa-times-circle ${props.className}`} />
      )}
    </Fragment>
  );
}

interface Props {
  loading: boolean;
  successful: boolean;
  className?: string;
}
